import React from 'react';
import { Typography } from "../ecosystem";

const FavoriteDrHeadings = ({
    heading
}) => {

    return (heading &&
        <div className="favorite-dr-headings-container">
            <Typography type="heading-02" tag="h2">
                {heading}
            </Typography>
        </div>
    );
}

export default FavoriteDrHeadings;
